// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-summary-header .close-icon {
  position: absolute;
  top: 24px;
  right: 24px;
}
.streams-drawer-summary-header .stream-description-wrapper {
  height: 24px;
}
.streams-drawer-summary-header .first-run-card {
  max-width: 930px;
  margin: 0 auto;
  margin-top: 48px;
  margin-bottom: 32px;
}
.streams-drawer-summary-header .first-run-text {
  flex: 1 1 65%;
}
.streams-drawer-summary-header .first-run-photo {
  flex: 1 1 35%;
}
@media (max-width: 975px) {
  .first-run-photo {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-summary-header/streams-drawer-summary-header.less"],"names":[],"mappings":"AAKA;EAGI,kBAAA;EACA,SAAA;EACA,WAAA;AANJ;AACA;EASI,YAAA;AAPJ;AAFA;EAaI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AARJ;AARA;EAoBI,aAAA;AATJ;AAXA;EAwBI,aAAA;AAVJ;AAcA;EACE;IACE,aAAA;EAZF;AACF","sourcesContent":["//\n// Copyright (c) 2011-2018 by Curalate, Inc.\n//\n@import (reference) '../../../css/unison';\n\n.streams-drawer-summary-header {\n\n  .close-icon {\n    position: absolute;\n    top: @cu-spacing-4;\n    right: @cu-spacing-4;\n  }\n\n  .stream-description-wrapper {\n    height: 24px;\n  }\n\n  .first-run-card {\n    max-width: 930px;\n    margin: 0 auto;\n    margin-top: 48px;\n    margin-bottom: 32px;\n  }\n\n  .first-run-text {\n    flex: 1 1 65%;\n  }\n\n  .first-run-photo {\n    flex: 1 1 35%;\n  }\n}\n\n@media (max-width: 975px) {\n  .first-run-photo {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
